import { daysUntilDue } from '../../utils/deadlineDates';

interface Props { dueDate: string | null; completed?: boolean; }

export default function DeadlineCountdown({ dueDate, completed }: Props) {
  if (completed) return <span className="rounded-full bg-gray-100 px-2.5 py-1 text-[11px] font-semibold leading-none text-gray-700">Done</span>;
  const d = daysUntilDue(dueDate);
  if (d === null) return <span className="text-xs text-gray-400">No date</span>;
  const cls =
    d < 0 ? 'bg-primary-100 text-primary-500'
    : d <= 1 ? 'bg-primary-100 text-primary-500'
    : d <= 7 ? 'bg-warning-wash text-warning'
    : 'bg-success-wash text-success';
  const label = d < 0 ? `${Math.abs(d)}d overdue` : d === 0 ? 'Due today' : `${d}d left`;
  return <span className={`whitespace-nowrap rounded-full px-2.5 py-1 text-[11px] font-semibold leading-none ${cls}`}>{label}</span>;
}
